// @flow

import {EventRules, EventRuleChange} from '@/types'

import * as React from 'react'
import {connect} from 'react-redux'
import {map, values} from 'ramda'
import {portfoliosActions, portfoliosSelectors} from '@/store'

import RuleGroup from './rule-group'

import './index.css'

type Props = {
  rules: EventRules,
  changeEventRule: (country: string, groupId: number, EventRuleChange) => void,
  country: string,
}

export const RawRules = (props: Props) => {
  const toRuleGroup = (g) =>
    <RuleGroup
      key={g.groupInfo.groupId}
      group={g}
      onChange={(change) => props.changeEventRule(
        props.country,
        g.groupInfo.groupId,
        change,
      )}
    />
  const rulesValues = values(props.rules[props.country] || {})
  return (
    <div className="rules columns-2">
      {map(
        toRuleGroup,
        rulesValues,
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  rules: portfoliosSelectors.getActivePortfolioRules(state),
})

export default connect(
  mapStateToProps,
  portfoliosActions,
)(RawRules)



// WEBPACK FOOTER //
// ./src/views/settings-page/rules/index.js